import * as tslib_1 from "tslib";
import { connect as reduxConnect } from 'react-redux';
export var connect = function connect(component, stateToProps, dispatchToProps, options) {
  return reduxConnect(stateToProps, dispatchToProps, undefined, options)(component);
};
export function createConnect(storeKey) {
  var res = function res(comp, s, d, o) {
    return connect(comp, s, d, tslib_1.__assign({}, o, {
      storeKey: storeKey
    }));
  };

  return res;
}